import integrationApi from "./integrationApi";
import Api from "./Api";
import store from "../state/store";

export default {
  getAllDirectories() {
    return integrationApi().get(`/integration/directories`);
  },

  createIntegration(params) {
    return integrationApi().post(
      `/integration/directories/auth/integration/entity/${store.getters["authfack/currentEntity"].id}/directory/${params.directory_type}/${params.fromStore ? 'edit' : 'new'}/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`,
      params.obj
    );
  },

  checkNameValidation(params) {
    return integrationApi().post(
      `/integration/validate_name/${store.getters["authfack/currentEntity"].id}`,
      params
    );
  },
  reAuthIntegration(params) {
    return integrationApi().post(
      `/integration/${params.integId}/reAuth`,
      params.obj
    );
  },

  getGridInetgrationsData() {
    return integrationApi().get(
      `/integration/directories/entity/${store.getters["authfack/currentEntity"].id}/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}/${store.getters["authfack/userDetails"].user_id}`
    );
  },

  getIntegration(id) {
    return integrationApi().get(`/directories/integration/${id}/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  getIntegrationWithMapping(id) {
    return integrationApi().get(`/integration/directories/${id}/mapping`);
  },

  getIntegrationStatus(id) {
    return integrationApi().get(`/integration/${id}/status`);
  },

  getIntegrationStat(id) {
    return integrationApi().get(`/integration/${id}/statistics/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  changeIntegrationStatus(id, status) {
    return integrationApi().put(`/integration/${id}/status/${status}`);
  },

  manageIntegrationSettings(params) {
    return integrationApi().post(`/integration/directory`, params);
  },

  editIntegrationSettings(params) {
    return integrationApi().put(`/integration/${params.id}/directory`, params);
  },

  updateIntegrationSettingsAndSync(params) {
    return integrationApi().put(`/integration/${params.id}/directory/sync/${JSON.parse(localStorage.getItem("userDetails")).id}`, params);
  },

  getFirstSync(id) {
    return integrationApi().get(`/integration/` + id + `/sync/firstSync/${JSON.parse(localStorage.getItem("userDetails")).id}`); // call again if id 5 || 4 || 8
  },

  getAutoSync(id) {
    return integrationApi().get(`/integration/` + id + `/sync/autoSync/${JSON.parse(localStorage.getItem("userDetails")).id}`, {
      params: {
        manual: 1
      },
    });
  },

  getFirstMigration(params) {
    return integrationApi().get(`/integration/` + params.id + `/migrateUsers/${JSON.parse(localStorage.getItem("userDetails")).id}`, {
      params: {
        log: params.log
      },
    });
  },

  getSyncUSerStatus(id) {
    return integrationApi().get(`/integration/synctempjob/` + id + `/status`);
  },

  getAllSyncedUsers(id) {
    return integrationApi().get(`/integration/` + id + `/users/synced/${store.getters["authfack/userDetails"].id}`);
  },

  getValidTempUsers(id) {
    return integrationApi().get(`/integration/${id}/tempUsers/valid/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  getTempUsersWithErrors(id) {
    return integrationApi().get(`/integration/${id}/tempUsers/error/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  getTempUsersWithDuplicates(id) {
    return integrationApi().get(`/integration/${id}/tempUsers/duplicate/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  fixTempUsersWithErrors(params) {
    return integrationApi().put('/integration/' + store.getters["authfack/currentEntity"].id + '/fixError/0', params.user);
  },

  fixTempUsersWithDuplicates(params) {
    return integrationApi().put('/integration/tempUsers/' + params.id + '/fixDuplicate', params);
  },

  getRedirectType(id) {
    return integrationApi().get(`/integration/firstSync/${id}/redirect/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  getUserTypes() {
    return integrationApi().get(`/integration/directories/entity/int/roles/${store.getters["authfack/currentEntity"].id}/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`);
  },

  deleteIntegration(id) {
    return integrationApi().delete(`integration/directory/` + id);
  },

  getSyncLogsList(id) {
    return integrationApi().get(`integration/SyncLogs/${id}`);
  },
 
  getSyncAttendanceCodesService(id) {
    return Api().get(`get_attendance_code/${store.getters["authfack/currentEntity"].id}/${id}`);
  },

  editTerminology(payload) {
    return Api().post(`attendance_codes/bulk-update`, {attendance_codes: payload});
  },

  getUsersTypes(id) {
    return integrationApi().get(`integration/userType/${id}`);
  },

  checkDuplicate(id) {
    return integrationApi().get(`integration/${store.getters["authfack/currentEntity"].id}/${id}/checkDuplicate`);
  },

  getSelectedSitesAreas(selectedSites, dir_id) {
    const data = {
      site_ids: selectedSites,
    }
    return integrationApi().post(`integration/areas/${dir_id}/${store.getters["authfack/userDetails"].id}/${store.getters["authfack/currentEntity"].owner_id}`, data);
  },

  preRequest(payload) {
    return integrationApi().post(`integration/preRequest`, payload);
  },
  getAreas(code, data) {
    return integrationApi().post(`integration/${code}/areas`, data);
  },

  findIntegration(id) {
    return integrationApi().get(`integration/info/${id}`);
  },
  
  getWondeIntegrations(){
    return integrationApi().get(`/integration/directories/wonde/entity/${store.getters["authfack/currentEntity"].id}/${store.getters["authfack/userDetails"].id}`);
  },

  refreshMapping(id) {
    return integrationApi().get(`/integration/${id}/refresh`);
  },

  fetchIntegrationScans(id) {
    return Api().get(`/get_intgration_scancs_list/${store.getters["authfack/currentEntity"].id}/${id}`);
  },

  syncIntegrationScans(payload) {
    return integrationApi().post(`/integration/writeBack/${payload.intgId}/scans`, {
      scan_ids: payload.ids
    });
  },

  ignoreIntegrationScans(payload) {
    return Api().put(`/ignore_intgration_scancs`, payload);
  },

  editIntegrationScans(payload) {
    return Api().put(`/edit_intgration_scancs`, payload);
  },

  fetchIntegrationAttendanceCodes(id) {
    return Api().get(`/get_attendance_code/${store.getters["authfack/currentEntity"].id}/${id}`);
  },
};